import { Form, FormFieldType } from "../Form";

export class PropertyRelationshipForm extends Form {
  protected definition = {
    relationshipRole: { type: FormFieldType.Selection, required: true },
    relationshipPerson: { type: FormFieldType.Selection, required: true }
  };
}
